<template>
    <div>
        <b-card class="bg-default-card no-padding" v-if="relation && trajectory_enrolment && milestone_progress">
            <b-tabs card>
                <b-tab :title="uLang('app.entity_details', { entity: lang('app.milestone_progress') })" active>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="inner">
                                <div class="row">
                                    <div class="col-md-6">
                                        <table class="table custom-stripe">
                                            <tr>
                                                <td width="200">{{ uLang('app.project_name') }}: </td>
                                                <td>
                                                    <link-if-permissions permissions="view-trajectory-projects" :to="{ name: 'admin.trajectory_projects.view', params: { id: trajectory_enrolment.trajectory_project_id }}">
                                                        {{ trajectory_enrolment.trajectory_project.name }}
                                                    </link-if-permissions>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="200">{{ uLang('app.trajectory_name') }}: </td>
                                                <td>
                                                    <link-if-permissions permissions="view-trajectories" :to="{ name: 'admin.trajectory_projects.trajectories.view', params: { projectId: trajectory_enrolment.trajectory_project_id, id: trajectory_enrolment.trajectory_id }}">
                                                        {{ trajectory_enrolment.trajectory.name }}
                                                    </link-if-permissions>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="200">{{ uLang('app.milestone_name') }}: </td>
                                                <td>
                                                    <link-if-permissions permissions="view-milestones" :to="{ name: 'admin.trajectory_projects.trajectories.milestones.view', params: { projectId: trajectory_enrolment.trajectory_project_id, trajectoryId: trajectory_enrolment.trajectory_id, id: milestone_progress.milestone_id }}">
                                                        {{ milestone_progress.milestone.name }}
                                                    </link-if-permissions>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="200">{{ uLang('app.start_date_milestone') }}: </td>
                                                <td>{{ milestone_progress.milestone_start_date | date }}</td>
                                            </tr>
                                            <tr>
                                                <td width="200">{{ uLang('app.end_date_milestone') }}: </td>
                                                <td>{{ milestone_progress.milestone_end_date | date }}</td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="col-md-6">
                                        <table class="table custom-stripe">
                                            <tr>
                                                <td width="200">{{ uLang('app.name') }}: </td>
                                                <td>
                                                    <link-if-permissions permissions="view-relations" :to="{ name: 'admin.relations.view', params: { id: trajectory_enrolment.relation_id }}">
                                                        {{ trajectory_enrolment.relation.full_name }}
                                                    </link-if-permissions>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td width="200">{{ uLang('app.remaining_hours') }}: </td>
                                                <td>-0:00</td>
                                            </tr>
                                            <tr>
                                                <td width="200">{{ uLang('app.maximum_hours') }}: </td>
                                                <td>0</td>
                                            </tr>
                                            <tr>
                                                <td width="200">{{ uLang('app.fact_sheet') }}: </td>
                                                <td>
                                                    <a :href="route('trajectory-projects.fact-sheet.download', {'trajectory_project': this.trajectory_enrolment.trajectory_project_id})">
                                                        {{ this.trajectory_enrolment.trajectory_project.fact_sheet ? this.trajectory_enrolment.trajectory_project.fact_sheet.name + '.' + this.trajectory_enrolment.trajectory_project.fact_sheet.extension : null }}
                                                    </a>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 tabs-show-area">
                            <b-card no-body class="mt-3">
                                <b-tabs card>
                                    <b-tab :title="uLang('app.action_progress')" active>
                                        <action-progress-table
                                            :url="route('relations.trajectory-enrolments.milestone-progresses.action-progresses.table', {
                                                relation: trajectory_enrolment.relation_id,
                                                trajectory_enrolment: trajectory_enrolment.id,
                                                milestone_progress: milestone_progress.id,
                                            })"
                                            :relation="trajectory_enrolment.relation"
                                            :trajectoryEnrolment="trajectory_enrolment"
                                            :milestoneProgress="milestone_progress"
                                        />
                                    </b-tab>
                                </b-tabs>
                            </b-card>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
    import ActionProgressTable from '~/components/tables/admin/relation/trajectory-enrolment/action-progress/table'

    export default {
        name: 'show',

        components: {
            'action-progress-table': ActionProgressTable,
        },

        props: {
            relationId: {
                required: true,
            },
            trajectoryEnrolmentId: {
                required: true,
            },
            milestoneProgressId: {
                required: true,
            },
        },

        data: function () {
            return {
                relation: null,
                trajectory_enrolment: null,
                milestone_progress: null,
            }
        },

        created: function () {
            this.retrieveRelation();
            this.retrieveTrajectoryEnrolment();
            this.retrieveMilestoneProgress();
        },

        methods: {
            async retrieveRelation() {
                const { data } = await window.axios.get(route('relations.show', { relation: this.relationId }));
                this.relation = data;
            },

            async retrieveTrajectoryEnrolment() {
                const { data } = await window.axios.get(route('relations.trajectory-enrolments.show', {
                    relation: this.relationId,
                    trajectory_enrolment: this.trajectoryEnrolmentId,
                }));
                this.trajectory_enrolment = data;
            },

            async retrieveMilestoneProgress() {
                const { data } = await window.axios.get(route('relations.trajectory-enrolments.milestone-progresses.show', {
                    relation: this.relationId,
                    trajectory_enrolment: this.trajectoryEnrolmentId,
                    milestone_progress: this.milestoneProgressId,
                }));
                this.milestone_progress = data;
            },
        }
    }
</script>

<style lang="css" scoped>
    .relation_image {
        max-width: 100%;
        max-height: 350px;
    }
    .detail-buttons {
        margin-bottom: 15px;
        float: right;
    }
    .add_address {
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .action_icon {
        cursor: pointer;
        margin-right: 5px;
    }
    .address_block a{
        margin-right: 10px;
    }
</style>
